import { Coupon, CouponListProps } from './types';

export const transformProductCoupons = (
  coupons: Coupon[],
  deltaAppliedCouponText?: string,
  previousCoupons: CouponListProps[] = []
) => {
  let couponsList: Coupon[] = [];
  if (previousCoupons.length) {
    previousCoupons.map((previousCoupon) => {
      coupons.map((coupon) => {
        if (previousCoupon.couponId === coupon.couponDetails.couponId) {
          couponsList.push(coupon);
        }
      });
    });
  } else {
    couponsList = coupons;
  }
  return couponsList?.map((coupon: Coupon) => ({
    offerId: coupon.offerId,
    title: coupon.title,
    description: coupon.description,
    offerType: coupon.offerType,
    viewProducts: coupon.viewProducts,
    future: coupon.future,
    couponDescription: coupon.couponDetails.description,
    couponCode: coupon.couponDetails.couponCode,
    expiry: coupon.couponDetails.expiry,
    couponId: coupon.couponDetails.couponId,
    couponStatus: coupon.couponDetails.couponStatus,
    discount: coupon.couponDetails.discount,
    imageUrl: coupon.couponDetails.imageUrl,
    fundingType: coupon.couponDetails.fundingType,
    label: coupon.couponDetails.label,
    couponStateLabel: coupon.couponDetails.couponStateLabel,
    prive: coupon.couponDetails.prive,
    priveCouponType: coupon.couponDetails.priveCouponType,
    subTitle: coupon.couponDetails.subTitle,
    couponTitle: coupon.couponDetails.title,
    deltaCouponDTO: coupon.couponDetails.deltaCouponDTO,
    deltaAppliedCouponText: deltaAppliedCouponText || '',
    deltaAmount: coupon?.deltaAmount,
    deltaQuantity: coupon?.deltaQuantity,
    deltaTextModified: coupon?.deltaTextModified,
    priveTier: coupon.couponDetails.priveTier,
    expiryEpoch: coupon.expiryEpoch,
    movMoqInfoDTO: coupon.couponDetails.movMoqInfoDTO || {},
  }));
};
